export default "https://acko-car-journey.ackoassets.com/next_assets/60e2d0ba57ef9a3ce35fdd159c9d291704170ded/_next/static/7ef1de26a09b3a2dbda130453be10fa1.png";